import styled from "styled-components";
import InaingLogo from "../../assets/images/logo/logo-inaing.png";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import LogoFull from "../logo/LogoFull";
import H2 from "../typography/H2";

const EmailIcon = "https://img.icons8.com/ios-filled/50/000000/new-post.png";
const PhoneIcon = "https://img.icons8.com/ios-filled/50/000000/phone.png";
const WhatsappIcon =
  "https://img.icons8.com/ios-filled/50/25/000000/whatsapp.png";
const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.div``;
const TopFooter = styled.div`
  height: 120px;
  width: 100%;
  background-color: ${colors.backgroundSurfacePrimary};
`;
const Line = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${colors.black};
`;
const TopContainer = styled.div`
  height: 100%;
  width: 100vw;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  h2 {
    font-size: ${fontSize.m};
  }
  p {
    font-size: ${fontSize.s};
    color: ${colors.textMuted};
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  @media (max-width: 500px) {
    h2 {
      font-size: ${fontSize.s};
    }
    p {
      display: none;
    }
    div {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
`;

const BottomFooter = styled.div`
  background-color: ${colors.backgroundPrimary};
  padding: 40px 10%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  * {
    letter-spacing: 0px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
  }

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 20px;

    > :nth-child(1) {
      order: 1;
    }

    > :nth-child(2) {
      order: 2;
    }

    > :nth-child(3) {
      order: 3;
    }

    > :nth-child(4) {
      order: 4;
    }
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  h2 {
    font-weight: 400 !important;
    font-size: ${fontSize.s};
    margin-bottom: 8px;
  }

  p {
    font-weight: 400 !important;
    font-size: ${fontSize.xs};
    color: ${colors.textMuted};
  }

  @media (max-width: 700px) {
    &:nth-child(2),
    &:nth-child(3) {
      flex: 0 0 48%;
    }
  }
`;

const ColumnsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  order: 2;

  @media (max-width: 700px) {
    flex-wrap: wrap;
    gap: 20px;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 20px;
    height: 20px;
  }

  a,
  span {
    font-size: ${fontSize.s};
    color: ${colors.textMuted};
    text-decoration: none;
  }
`;

const CopyrightSection = styled.div`
  cursor: pointer;
  width: 100%;
  height: 40px;
  img {
    height: 20px;
  }
  color: #172d5f;
  font-size: ${fontSize.s};
  display: flex;
  align-items: center;
  width: fit-content;
  margin: auto;
  gap: 5px;
  letter-spacing: 1.5px;
`;

function Footer() {
  return (
    <Wrapper>
      <Container>
        <TopFooter>
          <TopContainer>
            <div>
              <H2>Genuine Product</H2>
              <p>Verified for every order</p>
            </div>
            <div>
              <H2>No Refund</H2>
              <p>Purchased items cannot be returned</p>
            </div>
            <div>
              <H2>Exchange Only</H2>
              <p>Within 7 days of purchase conditions apply</p>
            </div>
            <div>
              <H2>Worldwide Shipping</H2>
              <p>Shipped globally with applicable charges.</p>
            </div>
          </TopContainer>
        </TopFooter>
        <Line />
        <BottomFooter>
          <Column>
            <LogoFull />
            <p>
              Wallet Menswear provides high-quality, sustainable fashion with a
              focus on craftsmanship and timeless design.
            </p>
          </Column>

          <ColumnsContainer>
            <Column>
              <H2>Categories</H2>
              <p>Clothing</p>
              <p>Shoes</p>
              <p>Accessories</p>
              <p>Bags</p>
            </Column>

            <Column>
              <H2>Follow Us</H2>
              <p>Facebook</p>
              <p>Instagram</p>
              <p>Tiktok</p>
            </Column>
          </ColumnsContainer>

          <Column>
            <H2>Contact</H2>
            <ContactItem>
              <img src={PhoneIcon} alt="Phone" />
              <span>+977 9867071416</span>
            </ContactItem>
            <ContactItem>
              <img src={PhoneIcon} alt="Phone" />
              <span>+977 9815329869</span>
            </ContactItem>
            <ContactItem>
              <img src={EmailIcon} alt="Email" />
              <a href="mailto:info@walletmenswear.com">
                info@walletmenswear.com
              </a>
            </ContactItem>
            <ContactItem>
              <img src={WhatsappIcon} alt="WhatsApp" />
              <a
                href="https://wa.link/ytkgxt"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp
              </a>
            </ContactItem>
          </Column>
        </BottomFooter>
      </Container>
      <CopyrightSection
        onClick={() => {
          window.open("https://inaing.com");
        }}
      >
        Developed by
        <img src={InaingLogo} alt="Inaing" />
      </CopyrightSection>
    </Wrapper>
  );
}

export default Footer;
